import { Block, media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledBlockContractInfo = styled(Block)`
  padding-left: 16px;
  padding-right: 16px;
  box-shadow: rgb(0 0 0 / 6%) 0px 0px 0px 0px;
  margin-left: -16px !important;
  margin-right: -16px !important;
  border-radius: 0px;

  ${media.sm`
    padding-left: 32px;
    padding-right: 34px;
    margin-left: -32px !important;
    margin-right: -32px !important;
  `}
`;
